var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-/-settings3-/-white",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8,4 L14.8002881,6.77335513 C15.267325,6.90814802 15.7126818,7.09406385 16.1299068,7.32465098 L18.0911688,5.36324676 L20.6367532,7.90883118 L18.6755479,9.87045306 C18.9061023,10.2876815 19.0919863,10.7330383 19.2267488,11.2000722 L22,11.2 L22,14.8 L19.2266449,14.8002881 C19.091852,15.267325 18.9059361,15.7126818 18.675349,16.1299068 L20.6367532,18.0911688 L18.0911688,20.6367532 L16.1299068,18.675349 C15.7126818,18.9059361 15.267325,19.091852 14.8002881,19.2266449 L14.8,22 L11.2,22 L11.2000722,19.2267488 C10.7330383,19.0919863 10.2876815,18.9061023 9.87045306,18.6755479 L7.90883118,20.6367532 L5.36324676,18.0911688 L7.32465098,16.1299068 C7.09406385,15.7126818 6.90814802,15.267325 6.77335513,14.8002881 L4,14.8 L4,11.2 L6.77325117,11.2000722 C6.90801368,10.7330383 7.09389769,10.2876815 7.32445213,9.87045306 L5.36324676,7.90883118 L7.90883118,5.36324676 L9.87045306,7.32445213 C10.2876815,7.09389769 10.7330383,6.90801368 11.2000722,6.77325117 L11.2,4 L14.8,4 Z M13,9.68421053 C11.16874,9.68421053 9.68421053,11.16874 9.68421053,13 C9.68421053,14.83126 11.16874,16.3157895 13,16.3157895 C14.83126,16.3157895 16.3157895,14.83126 16.3157895,13 C16.3157895,11.16874 14.83126,9.68421053 13,9.68421053 Z",
    id: "Shape",
    fill: "#FFFFFF",
    transform: "translate(13.000000, 13.000000) rotate(22.500000) translate(-13.000000, -13.000000) "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon-settings.5e2bd4ae.svg";
export { ForwardRef as ReactComponent };